import React, { useState } from 'react'
import { browserName } from 'react-device-detect'

const BrowserCheck = ({ children }) => {
  const [isVisible, setIsVisible] = useState(true)

  const handleClose = () => {
    setIsVisible(false)
    const localAuth = localStorage.getItem('auth')
    var auth = JSON.parse(localAuth)
    auth['seen'] = true
    localStorage.setItem('auth', JSON.stringify(auth))
  }

  return (
    <>
      {isVisible && !JSON.parse(localStorage.getItem('auth'))['seen'] && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <div style={styles.header}>
              <h1>Best Viewed in Google Chrome</h1>
              <button onClick={handleClose} style={styles.closeButton}>
                &times;
              </button>
            </div>
            <p style={styles.message}>
              This application is optimized for Google Chrome. Using other
              browsers ({browserName}) may impair certain functionalities,
              including navigation, due to variations in modern web browser
              standards. For the best experience, we recommend using Google
              Chrome.
            </p>
            <a
              href="https://www.google.com/chrome/"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              Download Chrome
            </a>
          </div>
        </div>
      )}
      {children}
    </>
  )
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    width: '80%',
    maxWidth: '500px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
  },
  message: {
    fontSize: '18px',
    marginBottom: '24px',
    color: '#666',
  },
  link: {
    fontSize: '18px',
    color: '#1a73e8',
    textDecoration: 'none',
  },
}

export default BrowserCheck
